export const getUserGroupList = state => {
    return state.list
}

export const getUserGroupDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/userGroup/getters.js